// Что CV-модуль принимает в report_mode="client" — копия
// lgp_cv_module/main/business_logic/client_mode.py (CLIENT_MODE_EXERCISE_IDS).
// Меняется там — меняем здесь; cvClientMode.test.js
// проверяет по ней все упражнения, которые мы отправляем.

/** Видео-упражнения фабрики CV-модуля с id < 40 (на base_classes/new_base). */
export const CLIENT_MODE_EXERCISE_IDS = new Set([
  1, 2, 3, 4, 6, 10, 11, 12, 13, 14, 16, 17, 19, 21, 24, 27, 28, 29, 32, 33, 34, 35, 36, 37,
]);

/**
 * Поля offer для калибровки в шкале (и фоновой сессии шкалы): там её не
 * запускаем (~240 кадров нейтрального лица на одну пробу). Тренажёр их не
 * шлёт и калибрует в каждой сессии. Есть сохранённая —
 * отдаём её; нет — только флаг, и CV-модуль берёт свои средние
 * (DEFAULT_CALIBRATION, lgp_cv_module MR !39). Чисел своих не держим.
 */
export const calibrationFields = (stored) => (
  stored ? { skip_calibration: true, calibration_info: stored } : { skip_calibration: true }
);
